export default {
  buttons: {
    next: "次へ",
    prev: "戻る",
    skip: "スキップ",
    done: "完了",
    gotIt: "了解",
  },
  messages: {
    dontShowAgainLabel: "今後表示しない",
    stepNumbersOfLabel: "/",
  },
};
